"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultDateWindow = void 0;
var models_1 = require("../../../models");
var latestDataDateWindow_1 = require("../types/latestDataDateWindow");
var lastNDateWindow_1 = require("../types/lastNDateWindow");
var allTimeDateWindow_1 = require("../types/allTimeDateWindow");
var defaultDateWindow = function (dateTrunc) {
    switch (dateTrunc) {
        case models_1.DateTrunc.SECOND: {
            return (0, latestDataDateWindow_1.createRelativeWindow)({
                unit: models_1.DateTrunc.MINUTE,
                numberOfUnits: 3,
            });
        }
        case models_1.DateTrunc.MINUTE: {
            return (0, latestDataDateWindow_1.createRelativeWindow)({
                unit: models_1.DateTrunc.HOUR,
                numberOfUnits: 3,
            });
        }
        case models_1.DateTrunc.HOUR: {
            return (0, latestDataDateWindow_1.createRelativeWindow)({
                unit: models_1.DateTrunc.DAY,
                numberOfUnits: 7,
            });
        }
        case models_1.DateTrunc.ISO_WEEKDAY:
        case models_1.DateTrunc.DAY: {
            return (0, latestDataDateWindow_1.createRelativeWindow)({
                unit: models_1.DateTrunc.DAY,
                numberOfUnits: 90,
            });
        }
        case models_1.DateTrunc.MONTH: {
            return (0, latestDataDateWindow_1.createRelativeWindow)({
                unit: models_1.DateTrunc.MONTH,
                numberOfUnits: 12,
            });
        }
        case models_1.DateTrunc.ISO_WEEK:
        case models_1.DateTrunc.WEEK: {
            return (0, latestDataDateWindow_1.createRelativeWindow)({
                unit: models_1.DateTrunc.WEEK,
                numberOfUnits: 52,
            });
        }
        case models_1.DateTrunc.ISO_QTR:
        case models_1.DateTrunc.QUARTER: {
            return (0, latestDataDateWindow_1.createRelativeWindow)({
                unit: models_1.DateTrunc.QUARTER,
                numberOfUnits: 8,
            });
        }
        case models_1.DateTrunc.ISO_YEAR:
        case models_1.DateTrunc.YEAR: {
            return (0, latestDataDateWindow_1.createRelativeWindow)({
                unit: models_1.DateTrunc.YEAR,
                numberOfUnits: 5,
            });
        }
        case models_1.DateTrunc.NONE: {
            return allTimeDateWindow_1.ALL_TIME_DATE_WINDOW;
        }
        case models_1.DateTrunc.UNKNOWN:
        case undefined:
        default: {
            return (0, lastNDateWindow_1.createLastNWindow)(100);
        }
    }
};
exports.defaultDateWindow = defaultDateWindow;
//# sourceMappingURL=defaultDateWindow.js.map